<template>
  <filter-badge-container>
    <date-from-filter-value @click.native="$emit('toggle-date-from-picker')"
                            @mouseover.native="isHover = true"
                            @mouseleave.native="isHover = false"
                            class="filter-menu-element rounded-l px-3"
                            :date="dateFrom"
                            id="test-date-from-filter-value"
    />
    <span class="h-3/5 w-px bg-black-a20" :class="{invisible: isHover}"></span>
    <date-to-filter-value @click.native="$emit('toggle-date-to-picker')"
                          @mouseover.native="isHover = true"
                          @mouseleave.native="isHover = false"
                          class="filter-menu-element rounded-r px-3"
                          :date="dateTo"
                          id="test-date-to-filter-value"
    />
  </filter-badge-container>
</template>

<script>

import FilterBadgeContainer from './FilterBadgeContainer'
import DateFromFilterValue from './DateFromFilterValue'
import DateToFilterValue from './DateToFilterValue'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'

export default {
  name: 'DateRangeFilterBadge',
  components: { DateFromFilterValue, DateToFilterValue, FilterBadgeContainer },

  data() {
    return {
      isHover: false
    }
  },

  computed: {
    dateFrom: analyticsFilterModule.getDateFrom,
    dateTo: analyticsFilterModule.getDateTo
  }
}
</script>
